import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Homedashboard from '../Pages/Homedashboard'
import Course from '../Pages/Course/Course'
import Allcourses from '../Pages/Course/Allcourses'
import Topic from '../Pages/Course/Topic'
import Check from '../Pages/Course/Pdfviewer'
import Subtopic from '../Pages/Course/Subtopic'
import Videoviewer from '../Pages/Course/Videoviewer'
import Privateroute from './Privateroute'
import Quiz from '../Pages/Course/Quiz/Quiz'
import Quizscore from '../Pages/Course/Quiz/Quizscore'
import Quizanswer from '../Pages/Course/Quiz/Quizanswer'
import Termsandcond from '../Home/Termsandcond'
import Privacypolicy from '../Home/Privacypolicy'
import Editprofile from '../Home/Login_Signup/Editprofile'
import Editprofileskeleton from '../Helper/Editprofileskeleton'
import Datanotfound from '../Helper/Datanotfound'
import Enrolltopic from '../Pages/Enrollcourse/Enrolltopic'
import DeleteAccountPage from '../Home/Login_Signup/DeleteAccountPage'

const Content = () => {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Homedashboard />} />
        <Route path='/course' element={<Course />} />
        <Route path='/all-course/:subId' element={<Allcourses />} />
        <Route path='/topic/:topicId' element={<Topic />} />
        <Route path='/enroll-topic' element={<Enrolltopic />} />
        <Route path='/subTopic' element={<Subtopic />} />
        <Route path='/pdf-viewer' element={<Check />} />
        <Route path='/quiz' element={<Quiz />} />
        <Route path='/quiz-score' element={<Quizscore />} />
        <Route path='/quiz-answer' element={<Quizanswer />} />
        <Route path='/video-viewer' element={<Videoviewer />} />
        <Route path='/terms-and-condition' element={<Termsandcond />} />
        <Route path='/privacy-policy' element={<Privacypolicy />} />
        <Route path='/deleteUserAccount' element={<DeleteAccountPage />} />

        <Route path='/notfound' element={<Datanotfound />} />
        <Route path='/privateRoute' element={<Privateroute />}>
              {/* <Route path='course' element={<Course />} /> */}
              {/* <Route path='all-course' element={<Allcourses />} /> */}
        </Route>
      </Routes>
    </div>
  )
}

export default Content